import Vue from "vue";

import { Component } from "@/decorators";

import "./view.scss";

@Component
export default class NotificationComponent extends Vue {}
